import React, { useState, useEffect } from 'react';

const EditCertificationModal = ({ isOpen, onClose, onCertificationUpdated, certificationToEdit, editingIndex }) => {
  const [formData, setFormData] = useState({
    name: '',
    issuingOrganization: '',
    issueDate: '',
    expiryDate: '',
    credentialId: '',
    credentialUrl: '',
    description: ''
  });
  const [error, setError] = useState('');

  // Update form data when certificationToEdit changes
  useEffect(() => {
    if (certificationToEdit) {
      setFormData({
        name: certificationToEdit.name || '',
        issuingOrganization: certificationToEdit.issuingOrganization || '',
        issueDate: certificationToEdit.issueDate || '',
        expiryDate: certificationToEdit.expiryDate || '',
        credentialId: certificationToEdit.credentialId || '',
        credentialUrl: certificationToEdit.credentialUrl || '',
        description: certificationToEdit.description || ''
      });
    }
  }, [certificationToEdit]);

  const handleSubmit = (e) => {
    e.preventDefault();
    
    if (!formData.name.trim() || !formData.issuingOrganization.trim()) {
      setError('Certification name and issuing organization are required');
      return;
    }

    try {
      setError('');
      
      // Notify parent component
      onCertificationUpdated(editingIndex, formData);
      
      // Close modal
      onClose();
    } catch (error) {
      console.error('Error updating certification:', error);
      setError('Error updating certification. Please try again.');
    }
  };

  const handleClose = () => {
    setError('');
    onClose();
  };

  if (!isOpen || !certificationToEdit) return null;

  return (
    <div className="modal-overlay" onClick={handleClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>Edit Certification</h2>
          <button 
            onClick={handleClose} 
            className="modal-close"
          >
            ×
          </button>
        </div>
        
        <form onSubmit={handleSubmit} className="modal-body">
          {error && (
            <div className="error-message">
              {error}
            </div>
          )}
          
          <div className="form-grid">
            <div className="form-group">
              <label className="form-label">Certification Name *</label>
              <input
                type="text"
                value={formData.name}
                onChange={(e) => setFormData({...formData, name: e.target.value})}
                className="input-field"
                placeholder="e.g., AWS Certified Solutions Architect"
                required
              />
            </div>
            <div className="form-group">
              <label className="form-label">Issuing Organization *</label>
              <input
                type="text"
                value={formData.issuingOrganization}
                onChange={(e) => setFormData({...formData, issuingOrganization: e.target.value})}
                className="input-field"
                placeholder="e.g., Amazon Web Services"
                required
              />
            </div>
          </div>

          <div className="form-grid">
            <div className="form-group">
              <label className="form-label">Issue Date</label>
              <input
                type="date"
                value={formData.issueDate}
                onChange={(e) => setFormData({...formData, issueDate: e.target.value})}
                className="input-field"
              />
            </div>
            <div className="form-group">
              <label className="form-label">Expiry Date</label>
              <input
                type="date"
                value={formData.expiryDate}
                onChange={(e) => setFormData({...formData, expiryDate: e.target.value})}
                className="input-field"
              />
            </div>
          </div>

          <div className="form-grid">
            <div className="form-group">
              <label className="form-label">Credential ID</label>
              <input
                type="text"
                value={formData.credentialId}
                onChange={(e) => setFormData({...formData, credentialId: e.target.value})}
                className="input-field"
                placeholder="e.g., AWS-123456789"
              />
            </div>
            <div className="form-group">
              <label className="form-label">Credential URL</label>
              <input
                type="url"
                value={formData.credentialUrl}
                onChange={(e) => setFormData({...formData, credentialUrl: e.target.value})}
                className="input-field"
                placeholder="https://credential.verification.url"
              />
            </div>
          </div>

          <div className="form-group">
            <label className="form-label">Description</label>
            <textarea
              value={formData.description}
              onChange={(e) => setFormData({...formData, description: e.target.value})}
              rows={3}
              className="input-field textarea-field"
              placeholder="Describe the certification, skills covered, or relevance to your career..."
            />
          </div>
          
          <div className="modal-actions">
            <button
              type="button"
              onClick={handleClose}
              className="btn btn-secondary"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="btn btn-primary"
            >
              Update Certification
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditCertificationModal; 